import Cookies from 'js-cookie'

const AUTH_SOURCES = ['insidedgodmode', 'openidconnect', 'token', 'oauth2', 'linkedin', 'facebook', 'saml']

export default () => {
  const { inSidedData, mixpanel, sessionStorage, localStorage } = window
  const { communityId, user: { userid, loginSource, registerSource } } = inSidedData
  const distinct_id = `${communityId}:${userid}`
  const mixpanelProjectToken = localStorage.getItem('mixpanel_project_token')
  const mixpanelCookie = Cookies.getJSON(`mp_${mixpanelProjectToken}_mixpanel`)

  if (!mixpanelCookie) return

  const hasBeenIdentified = mixpanelCookie.distinct_id === distinct_id
  const isSSOAuthenticated = AUTH_SOURCES.includes(loginSource) || AUTH_SOURCES.includes(registerSource)

  if (isSSOAuthenticated && !hasBeenIdentified) {
    mixpanel.identify(distinct_id)
    return
  }

  const UserLoggedIn = sessionStorage.getItem('UserLoggedIn') || null
  const UserRegistered = sessionStorage.getItem('UserRegistered') || null
  const UserLoggedOut = sessionStorage.getItem('UserLoggedOut') || null

  if (UserLoggedIn) {
    mixpanel.identify(distinct_id)
    sessionStorage.removeItem('UserLoggedIn')
    return
  }

  if (UserRegistered) {
    mixpanel.alias(distinct_id)
    sessionStorage.removeItem('UserRegistered')
    return
  }

  if (UserLoggedOut) {
    mixpanel.reset()
    sessionStorage.removeItem('UserLoggedOut')
    return
  }
}
